import retrieveAdditionalSalesIcons from '@/shared/icons/retrieveAdditionalSalesIcons'
import { useDispatch, useSelector } from 'react-redux'
import { useStyletron } from 'baseui'
import {
  selectAdditionalSalesConfig,
  selectConfig,
} from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSelectors'
import { useEffect } from 'react'
import { updateActiveTab, updateAdditionalSalesConfig } from '../../SubscriptionForm/SubscriptionFormSlice'
import { modulesConfig } from '@/containers/SubscriptionFormPageNew/config'
import { questIconOverrides } from './styled-components'

const useCreditBooster = country => {
  const dispatch = useDispatch()
  const [, theme] = useStyletron()
  const { scrollToAdditionalSaleTab, existingSalesLoaded } = useSelector(selectAdditionalSalesConfig)
  const { contactId } = useSelector(selectConfig)
  const creditBoosterEnabled = modulesConfig[country]?.additionalSales?.creditBooster ?? true

  const getIcon = (iconName, sold = false) =>
    retrieveAdditionalSalesIcons(
      iconName,
      20,
      questIconOverrides,
      sold ? theme.colors.positive600 : theme.colors.primary,
    )

  useEffect(() => {
    if (scrollToAdditionalSaleTab) {
      dispatch(updateActiveTab('additional-sales'))
      dispatch(updateAdditionalSalesConfig({ scrollToAdditionalSaleTab: false }))
    }
  }, [scrollToAdditionalSaleTab])

  return {
    getIcon,
    creditBoosterEnabled,
    contactId,
    existingSalesLoaded: existingSalesLoaded === true,
  }
}

export default useCreditBooster
